<i18n>
{
  "en": {
    "form": {
      "placeholder": "Select template file"
    },
    "table": {
      "headers": {
        "created": "Uploaded at",
        "user": "Uploader",
        "description": "Description",
        "actions": "Rollback",
        "filename": "Filename"
      },
      "all": "All"
    },

    "titles":{
      "current": "Current template",
      "upload": "Upload template",
      "history": "Template history",
      "rollback": "Rollback template definition"
    },
    "texts":{
      "rollback": "This action will rollback the current template definition to the file {name} which was uploaded at {timestamp} by {email}. Do you wish to perform the rollback?"
    },
    "buttons":{
      "upload": "Upload",
      "uploading": "Uploading",
      "rollback": "Rollback to",
      "download": "Download"
    },
    "alerts":{
      "success": "Template uploaded successfully",
      "danger": "Error uploading template file"
    }
  }, 
  "da": {
    "form": {
      "placeholder": "Vælg skabelonsfil"
    },
    "table": {
      "headers": {
        "created": "Uploadet",
        "user": "Uploader",
        "description": "Beskrivelse",
        "actions": "Rul tilbage",
        "filename": "Filnavn"
      },
      "all": "Alle"
    },
    "titles":{
      "current": "Nuværende skabelon",
      "upload": "Upload skabelon",
      "history": "Skabelonshistorik",
      "rollback": "Rul skabelons definiton tilbage"
    },
    "texts":{
      "rollback": "Denne handling vil rulle den nuværende skabelonsdefinition tilbage til filen {name}, som blev uploaded kl. {timestamp} af {email}. Ønsker du at udføre denne tilbagerulning?"
          },
    "buttons":{
      "upload": "Upload",
      "uploading": "Uploader",
      "rollback": "Rul tilbage",
      "download": "Download"
    },
    "alerts":{
      "success": "Skabelon uploaded successfuldt",
      "danger": "Fejl under upload af skabelon"
    }
  }
}
</i18n>

<template>
  <layout>
    <b-container fluid>
      <b-row>
        <b-col lg="12" offset-lg="0" class="pt-1"> 
          <b-card no-body>
            <b-tabs card v-model="tab">
              <b-tab :title="$t('titles.current')" > 

                <b-form>
                  <b-form-group :label="$t('table.headers.filename')" label-for="input-1" horizontal :label-cols="2" >
                    <b-form-input v-model="currentTemplate.Filename" disabled></b-form-input>
                  </b-form-group>
                  
                  <b-form-group :label="$t('table.headers.user')" label-for="input-1" horizontal :label-cols="2" >
                    <b-form-input v-model="(currentTemplate.User || {}).Email" disabled></b-form-input>
                  </b-form-group>

                  <b-form-group :label="$t('table.headers.created')" label-for="input-1" horizontal :label-cols="2" >
                    <b-form-input v-model="currentTemplateCreated" disabled>
                    </b-form-input>
                  </b-form-group>

                  <b-form-group :label="$t('table.headers.description')" label-for="input-1" horizontal :label-cols="2" >
                    <b-form-input v-model="currentTemplate.Description" disabled></b-form-input>
                  </b-form-group>
                  
                  <b-form-group label="" horizontal :label-cols="2">
                    <b-row>
                      <b-col md="12" lg="2">
                        <b-button variant="outline-primary" v-on:click="download(currentTemplate)" block>
                          {{$t('buttons.download')}}
                        </b-button>
                      </b-col>
                    </b-row>

                  </b-form-group>

                </b-form>

              </b-tab>

              <b-tab :title="$t('titles.upload')" >
                <form enctype="multipart/form-data" @submit.prevent="validateBeforeSubmit" onsubmit="return false">
                
                  <b-form-file class="mb-3" v-model="file" accept=".csv" :placeholder="$t('form.placeholder')" :change="reset()"></b-form-file>
                  
                  <b-form-group>
                    <b-form-textarea 
                      class="mb-3" 
                      v-model="description" 
                      name="description"
                      :disabled="formDisabled"
                        v-validate="'required:true|min:20|max:500|upload_description'">
                      >

                    </b-form-textarea>
                    <span class="error" v-if="errors.has('description')">{{errors.first('description')}}</span>
                  </b-form-group>


                  <b-button block variant="success" type="submit" :disabled="formDisabled" v-if="stateInitial || stateUploading">
                    <div v-if="stateUploading">
                      <font-awesome-icon icon="spinner" spin transform=""  :style="{ color: 'white' }" />
                      {{$t('buttons.uploading')}}
                    </div>

                    <div v-if="stateInitial">
                      {{$t('buttons.upload')}}
                    </div>
                  </b-button>
                
                  <b-alert variant="success" :show="stateSuccess" dismissible>{{$t('alerts.success')}}</b-alert>
                  <b-alert variant="danger" :show="stateError" dismissible>{{$t('alerts.danger')}}</b-alert>

                </form>
              </b-tab>

              <b-tab :title="$t('titles.history')">
                <b-table striped hover :items="templates"  :fields="fields" small responsive="xl" >
                  
                  <template v-slot:head(Created.ReferenceUsername)="scope">
                    {{$t('table.headers.created')}}
                  </template>
                  <template v-slot:head(User.Email)="scope">
                    {{$t('table.headers.user')}}
                  </template>
                  <template v-slot:head(Description)="scope">
                    {{$t('table.headers.description')}}
                  </template>
                  <template v-slot:head(Actions)="scope">
                    {{$t('table.headers.actions')}}
                  </template>

                  <template v-slot:cell(Created)="data">
                    {{ parseDate (data.item.Created) }}
                  </template>

                  <template v-slot:cell(Actions)="data">
                    <b-button size="sm" variant="outline-primary" v-on:click="download(data.item)">
                      {{$t('buttons.download')}}
                    </b-button>

                    <b-button size="sm"  variant="danger" :disabled="data.item.FileRank === 1" v-on:click="rollbackModal(data)">
                      {{$t('buttons.rollback')}}
                    </b-button>

                  </template>
                </b-table>      
              </b-tab>

            </b-tabs>
          </b-card>
        </b-col>
      </b-row>
    </b-container>

    <b-modal ref="rollback-modal" :title="$t('titles.rollback')" hide-footer>
      <p class="my-4">
        {{$t('texts.rollback', {
          name: (this.selectedTemplate || {}).FileName,
          timestamp: parseDate((this.selectedTemplate || {}).Created),
          email: ((this.selectedTemplate || {}).User || {}).Email
        })}}
      </p>
      <b-button class="mt-3" block variant="danger" @click="rollback">{{$t('buttons.rollback')}}</b-button>
    </b-modal>

  </layout>
</template>

<script>
import moment from 'moment';
import FileSaver from 'file-saver'

import elg from '../api/elg.gateway.js'
import Layout from './Layout'

const STATE_INITIAL = 0, STATE_UPLOADING = 1, STATE_SUCCESS = 2, STATE_FAILED = 3;
const TAB_CURRENT = 0, TAB_UPLOAD = 1, TAB_HISTORY = 2;

export default {
  components: {
    Layout
  },
  data() {
    return {
      file: undefined,
      description: undefined,
      state: STATE_INITIAL,
      tab: TAB_CURRENT,
      // Current template
      currentTemplate: {},

      // table
      templates: [],
      selectedTemplate: undefined,
      fields: [
        'Created',
        'User.Email',
        'Description',
        'Actions'
      ]
    }   
  },
  
  computed: {
    stateInitial(){
      return this.state === STATE_INITIAL;
    },
    stateUploading(){
      return this.state === STATE_UPLOADING;
    },
    stateSuccess(){
      return this.state === STATE_SUCCESS;
    },
    stateError(){
      return this.state === STATE_FAILED;
    },
    formDisabled(){
      return this.state == STATE_UPLOADING || this.state == STATE_SUCCESS || this.state == STATE_FAILED;
    },
    currentTemplateCreated(){
      return this.parseDate((this.currentTemplate || {}).Created);
    }

  },
  methods: {
    parseDate (date){
      return moment(date).format('DD-MM-YYYY HH:mm')
    },
    validateBeforeSubmit(){
      this.$validator.validateAll().then(result => {
        if (result) {
          this.upload();
        }else{
        }
      });

    },
    upload(){
      this.state = STATE_UPLOADING;

      let formData = new FormData();
      formData.append('file', this.file);
      if(this.description != undefined && this.description != null)
        formData.append('description', this.description);

      elg()
      .post('/api/v1/templates', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      .then( res => {
        this.state = STATE_SUCCESS;
        return this.getTemplateHistory();
      })
      .then(res => {
        return this.getCurrentTemplate();
      })
      .then( () => {
        console.log("Setting tab");
        this.tab = TAB_CURRENT;
        //this.reset();

        this.description = undefined;
        this.file = undefined;
        this.state = STATE_INITIAL;
        
        return this.getTemplateHistory();
      })
      .catch( err => {
        this.state = STATE_SUCCESS;
      })
    },
    reset(){
      if(this.state != STATE_SUCCESS && this.state != STATE_UPLOADING){
        this.state = STATE_INITIAL;

        return;
      }
    },
    download(file){
      console.log("Download: " + file.Filename)
      elg()
      .get('/api/v1/files/' + file.FileID)
      .then((response) => {
        FileSaver.saveAs(new Blob([response.data]), file.Filename);
      });
    },
    rollbackModal(data){
      this.selectedTemplate = data.item;
      this.$refs['rollback-modal'].show();
    },
    rollback(){
      var modal = this.$refs['rollback-modal'];
      return elg()
        .patch(`/api/v1/templates/${this.selectedTemplate.FileID}`)
        .then(res =>{
          modal.hide();
          return this.getCurrentTemplate();
        })
        .then( () => {
          this.tab = TAB_CURRENT;
          return this.getTemplateHistory();
        })
        .catch(res => {

        });
    },

    // API Calls´
    getTemplateHistory(){
      return elg()
        .get(`/api/v1/files?FileTypeID=1000`)
        .then( res => {
          this.templates = res.data;
        })
    },
    getCurrentTemplate(){
      return elg()
      .get(`/api/v1/files?FileTypeID=1000&LatestOnly=True`)
      .then( res => {
        this.currentTemplate = res.data[0];
      })
    }
  },
  mounted(){
    this.getTemplateHistory();
    this.getCurrentTemplate();
  }
};
</script>

<style scoped>
  .error{
    color: red;
    font-size: 12px;
  }
</style>


// WEBPACK FOOTER //
// WebApp/components/TemplateDefinitions.vue